import type { AuthServiceMethods } from "@storytell/auth";
import { newErrorResult } from "@storytell/result";
export const useAuthNoOpMethods = (): AuthServiceMethods => {
  return {
    signInWithMagicLink: async () => {
      // no-op
    },
    signOut: async () => {
      // no-op
    },
    setupListeners: () => {
      // no-op
    },
    signInWithGoogle: () => Promise.resolve("not_signed_in"),
    finishSignInMagicLink: (_email: string, _redirectUrl: string) =>
      Promise.resolve(newErrorResult("not implemented", "Not implemented")),
    isURLMagicLink: (_url: string) => false,
    completeSignInWithToken: (_firebaseToken: string, _isNewUser: boolean) =>
      Promise.resolve(newErrorResult("not implemented", "Not implemented")),
    verifyMagicLink: () => Promise.resolve(newErrorResult("not implemented", "Not implemented")),
  };
};
